// @steered AudibleSecurityContext 1.2 2026-08-17

import type { AppetizePlatform, AppetizeSessionConfig } from './appetize.types';

const DEBUG_BUILD_IDS: Record<AppetizePlatform, string> = {
  ios: 'b_u32s3ay6i7ustjnzoj6hrqbs5m',
  android: 'b_3gqvxffiswu267yqsq75lj2vli',
};

const BASE_CONFIG: Record<AppetizePlatform, Omit<AppetizeSessionConfig, 'buildId'>> = {
  ios: {
    device: 'iphone14pro',
    osVersion: '26.0',
    audio: false,
    grantPermissions: true,
    screenOnly: true,
    scale: 'auto',
    // The debug app build exposes Developer Settings. SDK debug-log streaming is unnecessary.
    debug: false,
    hidePasswords: true,
  },
  android: {
    device: 'pixel7',
    osVersion: '13.0',
    audio: false,
    grantPermissions: true,
    screenOnly: true,
    scale: 'auto',
    debug: false,
    hidePasswords: true,
  },
};

export const getAppetizeConfig = (platform: AppetizePlatform): AppetizeSessionConfig => ({
  ...BASE_CONFIG[platform],
  buildId: DEBUG_BUILD_IDS[platform],
});
